import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'

import PartnershipForm from '../../PartnershipForm'

import { usePurifiedFormik } from '../../../../../../hooks/formHooks/usePurifiedFormik'

import { createPartnership, clearCreatePartnership } from '../../../../../../modules/actions/partnerships'
import { clearAllPlatformsSingleAdAccount } from '../../../../../../modules/actions/adAccounts'

import {
  createPartnershipErrorSelector,
  createPartnershipIsLoadingSelector,
  createPartnershipWasCreatedSelector,
  selectedPartnershipSelector
} from '../../../../../../modules/selectors/partnerships'

import { PARTNERSHIP_CREATE } from '../../../../../../constants/forms'
import {
  getInitialValues,
  transformAdAccountsToBE,
  transformValuesToBE,
  getValidationSchema
} from '../../PartnershipForm/fields'

const CreatePartnershipForm = () => {
  const dispatch = useDispatch()

  const { rights_holder: rightsHolderId } = useSelector(selectedPartnershipSelector)
  const createPartnershipWasCreated = useSelector(createPartnershipWasCreatedSelector)

  const onSubmit = useCallback(
    values => {
      dispatch(
        createPartnership({
          ...transformValuesToBE(values),
          ...transformAdAccountsToBE(values),
          rights_holder: rightsHolderId,
          display_rights: true,
          status: 'live'
        })
      )
    },
    [dispatch, rightsHolderId]
  )

  const formik = useFormik({
    initialValues: getInitialValues(),
    validationSchema: getValidationSchema({}),
    onSubmit
  })
  const purifiedFormik = usePurifiedFormik(formik)

  const clearCreatePartnershipHandler = useCallback(() => {
    dispatch(clearCreatePartnership())
    dispatch(clearAllPlatformsSingleAdAccount())
  }, [dispatch])

  return (
    <PartnershipForm
      formName={PARTNERSHIP_CREATE}
      formik={purifiedFormik}
      successSubmit={createPartnershipWasCreated}
      errorSelector={createPartnershipErrorSelector}
      isLoadingSelector={createPartnershipIsLoadingSelector}
      clearHandler={clearCreatePartnershipHandler}
    />
  )
}

export default CreatePartnershipForm
